export default __webpack_public_path__ + "static/media/brimstone-haunt-logo_xmas.24e599f9.png";